import React from 'react'

const NoPage = () => {
  return (

    <h1 style={{textAlign:'center'}}>ERROR 404</h1>
  
  )
}

export default NoPage